/* eslint-disable no-use-before-define */

import React from 'react'
import { trackPage, Loading } from '../twd/twd'
import { useTreasuryAuctions, ContextProvider } from './use-treasury-auctions'
import { Footer } from './footer'
import Auctions from './auctions'
import Chart from './chart'
import Upcoming from './upcoming'
import Schedules from './schedules'

export default (args) => {
    trackPage('treasury-auctions')

    return <React.Fragment>
        <ContextProvider {...args}>
            <Main />
        </ContextProvider>
        </React.Fragment>
}


const Main = (args) => {

    const { status } = useTreasuryAuctions()
    return <React.Fragment>
        <Loading status={status}>
            <Content />
        </Loading>
    </React.Fragment>

}

const Content = () => {
    return <React.Fragment>
        <div className="container treasury-auctions">

        <div className="row"><div className="col-xs-12">
        <div data-name="messages-message"
            className="universal-message universal-message-info universal-message-dismissible"
            role="alert">
            <div data-name="messages-message-content"
                className="universal-message-content"
                style={{width:'100%'}}
            >
            Cancel requests for open Treasury auction orders must be submitted prior to 9 AM ET;
            cancellation of an order is not guaranteed even if submitted prior to 9 AM ET.
            Please consult your E*TRADE from Morgan Stanley Client Agreement for Self-Directed Accounts for further information on order cancellations and other applicable terms and conditions.
            </div>
        </div>
        </div></div>

        <div className="row vertical-offset-xs">
        <div className="col-md-6 col-xs-12">
            <h2 className="large-header">Treasury Auctions</h2>
        </div>
        <div className="col-md-6 col-xs-12 text-right">
            <a href="https://www.treasurydirect.gov/auctions/announcements-data-results/announcement-results-press-releases/auction-results/"
                target="_blank"
                style={{textDecoration:'underline'}}
            >Today's auction results</a>
        </div>
        </div>

        <div className="row vertical-offset-xs">
        <div className="col-md-12 col-xs-12">
            <Auctions />
        </div>
        </div>

        <div className="row vertical-offset-xs">
        <div className="col-md-6 col-xs-12">
            <Upcoming />
        </div>
        <div className="col-md-6 col-xs-12">
            <Chart />
            <br/>
            <Schedules />
        </div>
        </div>

        </div>

        <Footer />
        </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/treasury-auctions/treasury-auctions.js